import * as React from 'react';

import type { IconProps } from '../types';

const StatusArchive = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 16, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden="true"
        {...props}
      >
        <rect
          x="2"
          y="7"
          width="12"
          height="2"
          rx="1"
          fill="hsl(var(--twc-status-icon-archive))"
        />
      </svg>
    );
  }
);

StatusArchive.displayName = 'StatusArchive';

export { StatusArchive };
